import React, { useState, useEffect } from 'react';
import '../css/components/Cart.css';
import extraImg from '../assets/empty-cart.gif';
import { Navigate, useNavigate } from 'react-router-dom';

const Cart = ({ setShowCart, userData }) => {
    const [cart, setCart] = useState([]);
const navigate = useNavigate();
    
    useEffect(() => {
        if(userData != null)
    updateCartFromStorage();
        // const savedCart = JSON.parse(localStorage.getItem('cart'));
        // console.log(savedCart);

        // if (savedCart && Array.isArray(savedCart)) {
        //     setCart(savedCart);
        // } else {
        //     setCart([]);
        // }
    }, []);


                const updateCartFromStorage = async () => {
        const response = await fetch(`https://api.kcmstore.in/store/get-mycart/${userData.id}`);
        if (response.ok) {
          const data = await response.json();
          console.log(data);
          const sortedProducts = data.sort((a, b) => b.id - a.id);
        setCart(sortedProducts || []);
        } else {
            setCart([]);
        }

        const savedCart = JSON.parse(localStorage.getItem('cart'));
        console.log(savedCart);
        // setCart(savedCart || []);
    };


//     const handleRemoveItem = async (productId) => {
//                        try {
//     const response = await fetch(`https://api.kcmstore.in/store/remove-cart/${productId}`, {
//       method: 'DELETE',
//       headers: { 'Content-Type': 'application/json' },
//     });

//     const data = await response.json();

//     if (response.ok) {
//       console.log('✅ Cart synced with backend:', data);
//       updateCartFromStorage();
//     } else {
//       console.error('❌ Failed to sync cart:', data.message || 'Unknown error');
//     }
//   } catch (error) {
//     console.error('⚠️ Network error while syncing cart:', error);
//   }

//         // const updatedCart = cart.filter(item => item.medicine_id !== productId);

//         // setCart(updatedCart);
//         // localStorage.setItem('cart', JSON.stringify(updatedCart));
//         window.dispatchEvent(new Event('cartUpdated'));
//     };


const handleRemoveItem = async (productId) => {
  try {
    const response = await fetch(`https://api.kcmstore.in/store/remove-cart/${productId}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    });

    const data = await response.json();

    if (response.ok) {
      console.log('✅ Cart synced with backend:', data);

    //   const updatedCart = (JSON.parse(localStorage.getItem('cart')) || []).filter(
    //     (item) => item.medicine_id !== productId
    //   );

    //   localStorage.setItem('cart', JSON.stringify(updatedCart));
    //   setCart(updatedCart);
      updateCartFromStorage();

      window.dispatchEvent(new Event('cartUpdated'));
    } else {
      console.error('❌ Failed to sync cart:', data.message || 'Unknown error');
    }
  } catch (error) {
    console.error('⚠️ Network error while syncing cart:', error);
  }
};



    const handleQuantityChange = (productId, action) => {
        const updatedCart = cart.map(item => {
            if (item.id == productId) {
                const newQuantity = action === 'increment' ? item.quantity + 1 : item.quantity - 1;
                return { ...item, quantity: Math.max(newQuantity, 1) };
            }
            return item;
        });

        setCart(updatedCart);
    };


    const calculateTotal = () => {
        return cart.reduce((total, product) => total + parseFloat(product.sell_price) * product.quantity, 0).toFixed(2);
    };

    const calculateTotalItem = () => {
        return cart.reduce((total, product) => total + product.quantity, 0);
    };


    return (
        <>
            <section className='cart-outer animate__animated animate__fadeInRight'>
                <div>
                    <span className='float-end cursor-pointer' onClick={() => setShowCart(false)}>
                        <i className="fa-solid fa-xmark"></i>
                    </span>
                    <p className='cart-heading'>Shopping Cart</p>

                    {cart.length === 0 ? (
                        <div className='text-center my-5'>
                            <p className='fw-semibold'>No Items added in Cart</p>
                            <img src={extraImg} className='img-fluid' style={{height: '16em'}} alt='empty cart' />
                        </div>
                    ) : (
                        <>
                            <div className='cart-item-outer'>
                                {cart.map((product) => (
                                    <div className='cart-item' key={product.medicine_id}>
                                        <div className='d-flex justify-content-between align-items-center'>

                                            <div className='d-flex text-start'>
                                                <img src={`https://api.kcmstore.in/sUploads/${product.image.split(',')[0]}`} className='col-lg-3 col-md-3 col-4' alt={product.name} />

                                                <div className='ms-3 align-content-center'>
                                                    <p className='featured-name'>{product.name} ({product.unit})</p>
                                                    <p className='featured-price'>₹ {product.sell_price * product.quantity}</p>
                                                    <p className='action-btn-area my-0'>
                                                        <span className='action-btn' onClick={() => handleQuantityChange(product.id, 'decrement')}>-</span>
                                                        <span className='px-2'>{product.quantity}</span>
                                                        <span className='action-btn' onClick={() => handleQuantityChange(product.id, 'increment')}>+</span></p>
                                                </div>
                                            </div>

                                            <span className='text-secondary fs-3 cursor-pointer' onClick={() => handleRemoveItem(product.id)}><i class="fa-solid fa-delete-left"></i></span>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className='bg-light px-3 py-3 rounded-3 mt-3'>
                                <p className='fw-bold'>Summary</p>
                                <div className='d-flex mb-2 justify-content-between'><span>Total Items:</span><span>{calculateTotalItem()}</span> </div>
                                <div className='d-flex mb-2 justify-content-between'><span>Order Total:</span><span>{calculateTotal()}</span> </div>
                            </div>

                            <div className='pay-area'>
                                <button className='login-btn2' onClick={() => {setShowCart(false); navigate('/checkout')}}>Check Out</button>
                            </div>
                        </>
                    )}
                </div>
            </section>
        </>
    );
};

export default Cart;
